import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const accommodationEntity: Entity = {
  model: model,
  repository: repository,
}

export default accommodationEntity
